import memoizee from "memoizee";

export function memoizeAsync({ maxAgeMs }: { maxAgeMs?: number } = {}) {
    return (target: any, propertyKey: string, descriptor: PropertyDescriptor) => {
        const memoized: Function = memoizee(descriptor.value, { promise: true, maxAge: maxAgeMs });
        descriptor.value = function (...args: any[]) {
            return memoized.apply(this, args);
        }
    };
}